import React from 'react'
// import Status from 'Lib/Status'
import { ROUTER_BASE_PATH } from 'AccountsConstants/routes'

const goToAccountsHome = () => {
  window.location.href = ROUTER_BASE_PATH
}

const ErrorScreen = props => {
  return (
    <div>
      <div className="flex flex-wrap flex-center flex-middle amt-50 apl-15 apr-15">
        <div className="w-100p ta-c amb-20 flex">
          <svg
            className="flex-auto"
            width="34"
            height="34"
            viewBox="0 0 18 16"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            fill="#FFBA00"
          >
            <defs>
              <path
                id="warning-a"
                d="M10.969 9.136h2.062v5.606H10.97V9.137zm0 7.01h2.062v1.868H10.97v-1.869zm9.948 2.783L12.566 4.325A.649.649 0 0 0 12 4a.65.65 0 0 0-.566.325l-8.35 14.604a.626.626 0 0 0 .004.636c.118.196.33.317.561.317h16.702c.23 0 .442-.121.56-.317a.631.631 0 0 0 .006-.636z"
              />
            </defs>
            <use
              fillRule="evenodd"
              xlinkHref="#warning-a"
              transform="translate(-3 -4)"
            />
          </svg>
          <h1 className="fs-20 fw-500 flex-auto amt-10 ta-l">
            Oops! Something went wrong
          </h1>
        </div>
        <div className="ta-c apb-20">
          <h2 className="fs-17 amb-15 c-black-60">
            The details for the user profile cannot be fetched at the moment.
            Please try again later.
          </h2>

          <button
            type="button"
            className="Button Button--medium Button--tertiary"
            onClick={goToAccountsHome}
          >
            Back to home
            <span className="Ripple" />
          </button>
        </div>
      </div>
    </div>
  )
}

export default ErrorScreen
